import React, { useEffect } from 'react'

const regex = /(<([^>]+)>)|\t|\n|&nbsp;/gi

const ReportTMPL = props => {

    // eslint-disable-next-line
    const { reportData, onLoaded } = props;

    // console.log(reportData)
    // console.log(
    //     reportData.map(d => ({ n: d.nazwa_systemu, l: d.gestor_level }))
    // )

    useEffect(() => {
        console.log('loaded')
    }, [])

    return (
        <>
            {reportData.map(item => {

                return (
                    <table
                        id={`reportData-table-${item.id_systemu}`}
                        key={`reportData-table-${item.id_systemu}`}
                        style={{
                            borderCollapse: 'collapse',
                            width: '100%',
                            tableLayout: 'fixed',
                            overflowWrap: 'break-word'
                        }}
                    >
                        <tbody>

                            {/* {!!item.kod_rsi
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10, width: 20 }} >
                                            {'ID'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: item.kod_rsi.replace(regex, "") }} />
                                        </td>
                                    </tr>
                                </>
                                : null
                            } */}
                            {!!item.nazwa_systemu
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Nazwa systemu'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 11 }}>
                                            <p>{item.nazwa_systemu}</p>
                                        </td>
                                    </tr>
                                </>
                                : null
                            }

                            {!!item.nazwa_systemu_skr
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Skrócona nazwa'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: item.nazwa_systemu_skr.replace(regex, "") }} />
                                        </td>
                                    </tr>
                                </>
                                : null
                            }
                            {!!item.gestor
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Gestor'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: item.gestor.replace(regex, "") }} />
                                        </td>
                                    </tr>
                                </>
                                : null}

                            {!!item.aktyprawne && !!item.aktyprawne.length
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Podstawa prawna'}
                                        </td>
                                    </tr>
                                    {

                                        item.aktyprawne.map(akt => {
                                            return (
                                                <tr key={`akt-${akt.id_akt}`}>
                                                    <td style={{ fontSize: 10 }}>
                                                        {`${akt.nazwa} ${akt.miejsce_publikacji}`}
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </>
                                : null}

                            {!!item.cel_systemu
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Cel systemu'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: item.cel_systemu.replace(regex, "") }} />
                                        </td>
                                    </tr>
                                </>
                                : null}

                            {!!item.sposob_prowadzenia_systemu
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Sposób prowadzenia systemu'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: item.sposob_prowadzenia_systemu.replace(regex, "") }} />
                                        </td>
                                    </tr>
                                </>
                                : null}

                            {!!item.zasieg_systemu
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Zasięg systemu'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: item.zasieg_systemu.replace(regex, "") }} />
                                        </td>
                                    </tr>
                                </>
                                : null}

                            {!!item.forma_prowadzenia_systemu
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Forma prowadzenia systemu'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: item.forma_prowadzenia_systemu.replace(regex, "") }} />
                                        </td>
                                    </tr>
                                </>
                                : null}

                            {!!item.zrodla_danych_czestotliwosc_aktualizacji
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Źródła danych i częstotliwość aktualizacji'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: item.zrodla_danych_czestotliwosc_aktualizacji.replace(regex, "") }} />
                                        </td>
                                    </tr>
                                </>
                                : null}

                            {!!item.termin_formy_udostepniania_danych
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Termin i formy udostępniania danych'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: item.termin_formy_udostepniania_danych.replace(regex, "") }} />
                                        </td>
                                    </tr>
                                </>
                                : null}

                            {!!item.stan_wdrozenia_systemu
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Stan wdrożenia systemu'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: item.stan_wdrozenia_systemu.replace(regex, "") }} />
                                        </td>
                                    </tr>
                                </>
                                : null}

                            {!!item.zmiany_planowane
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Zmiany planowane do wprowadzenia w systemie'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: item.zmiany_planowane.replace(regex, "") }} />
                                        </td>
                                    </tr>
                                </>
                                : null}

                            {!!item.planowany_termin_wdrozenia
                                ? <>
                                    <tr>
                                        <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                            {'Planowany termin wdrożenia'}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ fontSize: 10 }}>
                                            <span dangerouslySetInnerHTML={{ __html: item.planowany_termin_wdrozenia.replace(regex, "") }} />
                                        </td>
                                    </tr>
                                </>
                                : null}

                            {!!item.obiekty && !!item.obiekty.length
                                ? <>
                                    {
                                        item.obiekty.map(obiekt => {
                                            return (
                                                <React.Fragment key={`obiekt-${obiekt.id_obiektu}`}>
                                                    {!!obiekt.nazwa_obiektu
                                                        ? <>
                                                            <tr>
                                                                <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                                                    {'Nazwa obiektu'}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ fontSize: 10 }}>
                                                                    <span dangerouslySetInnerHTML={{ __html: obiekt.nazwa_obiektu.replace(regex, "") }} />
                                                                </td>
                                                            </tr>
                                                        </>
                                                        : null}
                                                    {!!obiekt.typ_obiektu
                                                        ? <>
                                                            <tr>
                                                                <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                                                    {'Typ obiektu'}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ fontSize: 10 }}>
                                                                    <span dangerouslySetInnerHTML={{ __html: obiekt.typ_obiektu.replace(regex, "") }} />
                                                                </td>
                                                            </tr>
                                                        </>
                                                        : null}

                                                    {true
                                                        ? <>
                                                            <tr>
                                                                <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                                                    {'Opis obiektu'}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ fontSize: 10 }}>
                                                                    <span dangerouslySetInnerHTML={{ __html: obiekt.opis_obiektu }} /> 
                                                                </td>
                                                            </tr>
                                                        </>
                                                        : null}

                                                    {true
                                                        ? <>
                                                            <tr>
                                                                <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                                                    {'Standardowe identyfikatory obiektu'}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ fontSize: 10 }}>
                                                                    {/* <span dangerouslySetInnerHTML={{ __html: obiekt.typ_obiektu }} /> */}
                                                                </td>
                                                            </tr>
                                                        </>
                                                        : null}

                                                    {!!obiekt.cechyobiektu && !!obiekt.cechyobiektu.length &&
                                                        obiekt.cechyobiektu.map(cecha => {
                                                            return (
                                                                <React.Fragment key={`cecha-${obiekt.id_obiektu}-${cecha.id_cechy}`}>
                                                                    {!!cecha.nazwa_cechy
                                                                        ? <>
                                                                            <tr>
                                                                                <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                                                                    {'Nazwa cechy informacyjnej'}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style={{ fontSize: 10 }}>
                                                                                    <span dangerouslySetInnerHTML={{ __html: cecha.nazwa_cechy.replace(regex, "") }} />
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                        : null}
                                                                    {!!cecha.definicja_cechy
                                                                        ? <>
                                                                            <tr>
                                                                                <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                                                                    {'Definicja cechy informacyjnej'}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td style={{ fontSize: 10 }}>
                                                                                    <span dangerouslySetInnerHTML={{ __html: cecha.definicja_cechy.replace(regex, "") }} />
                                                                                </td>
                                                                            </tr>
                                                                        </>
                                                                        : null}
                                                                    {!!cecha.aktyprawne && !!cecha.aktyprawne.length
                                                                        ? <>
                                                                            <tr>
                                                                                <td style={{ fontWeight: 'bold',fontFamily: 'Roboto-Bold', fontSize: 10 }}>
                                                                                    {'Normatywne źródło definicji cechy informacyjnej'}
                                                                                </td>
                                                                            </tr>
                                                                            {

                                                                                cecha.aktyprawne.map((akt, i) => {
                                                                                    return (
                                                                                        <tr key={`akt-${obiekt.id_obiektu}-${cecha.id_cechy}-${akt.id_akt || i}`}>
                                                                                            <td style={{ fontSize: 10 }}>
                                                                                                {`${akt.nazwa || ''} ${akt.miejsce_publikacji || ''}`}
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </>
                                                                        : null}
                                                                </React.Fragment>
                                                            )
                                                        })
                                                    }

                                                </React.Fragment>
                                            )
                                        })
                                    }
                                </>
                                : null}

                            <tr><td></td></tr>
                        </tbody>
                    </table>
                )
            })}
        </>
    )
}

export default ReportTMPL